import React, { memo, PropsWithChildren } from 'react';
import { is, fromJS } from 'immutable';

/**
 * 自定义memo高阶组件，实现props深层比较
 */
const MemoDeep = <T extends object>(funcComponent: React.FC<PropsWithChildren<T>>) =>
  memo(funcComponent, (prevValue, nextValue): boolean => {
    if (!prevValue || !nextValue) {
      return false;
    }
    if (Object.keys(prevValue).length !== Object.keys(nextValue).length) {
      return false;
    }

    for (const key in nextValue) {
      let prevProp = prevValue[key];
      let nextProp = nextValue[key];
      // 判断是否是Immutable类型的变量，不是则做一层转换
      if (!prevProp?.size || !nextProp?.size) {
        prevProp = fromJS(prevProp);
        nextProp = fromJS(nextProp);
      }
      if (!is(prevProp, nextProp)) {
        return false;
      }
    }
    return true;
  });

export default MemoDeep;
